import { Box, Button, FormControl, FormErrorMessage, FormLabel, Input, Text, Select, useToast, Link, Circle } from "@chakra-ui/react";
import { useEffect, useState, createRef, useRef } from "react";
import Dropzone from 'react-dropzone'
import { ReactComponent as AddPhoto } from '../../svg/AddPhoto.svg'
import { ReactComponent as UploadIcon } from '../../svg/Upload.svg'
import SwitchComponent from "../common/SwitchComponent";
import { useHistory } from 'react-router-dom'
import Tags from '../common/Tags'
import { useDispatch, useSelector } from "react-redux";
import { resetEdit, resetFormStatus, selectedMenu, setEdit, setHeaderText } from "../../redux/actions/actions";
import { loadCourses, loadTopics, submitTopicForm, updateTopicForm } from "../../redux/api_calls/apiCalls";
import JoditEditor from "jodit-react";

export default function CustomAddTopic() {
    const [topicImage, setTopicImage] = useState(null)
    const [topicImageUrl, setTopicImageUrl] = useState(null)
    const [keywordTags, setKeywordTags] = useState([])
    const [topicImageError, setTopicImageError] = useState(null)
    const [quizSwitchStatus, setQuizSwitchStatus] = useState(true)
    const [topicEnabledSwitchStatus, setTopicEnabledSwitchStatus] = useState(true)
    const [selectCourseError, setSelectCourseError] = useState(null)
    const [topicNameError, setTopicNameError] = useState(null)
    const [descriptionError, setDescriptionError] = useState(null)
    const [keywordsError, setKeywordsError] = useState(null)
    const [files, setFiles] = useState([])
    const [filesError, setFilesError] = useState(null)
    const [buttonClicked, setButtonClicked] = useState(0)
    const [contentLink, setContentLink] = useState(null)
    const coursesData = useSelector(state => state.coursesState.coursesData)
    const topicNameRef = useRef()
    const selectCourseRef = useRef()
    const formStatus = useSelector(state => state.formStatus)
    const headerText = useSelector(state => state.headerState.headerText)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()
    const dropzoneRef = createRef();
    const history = useHistory()
    const toast = useToast()

    const editState = useSelector(state => state.editState)
    const topicData = useSelector(state => state.topicsState.topicsData)

    const editor = useRef(null)
    const [content, setContent] = useState('')

    const openDialog = () => {
        // Note that the ref is set async,
        // so it might be null at some point 
        if (dropzoneRef.current) {
            dropzoneRef.current.open()
        }
    };



    function validateTopicName() {
        let topicName = topicNameRef.current.value.trim()
        if (!topicName.length) {
            setTopicNameError("Topic Name is required")
            return true
        }
        else {
            setTopicNameError(null)
            return false
        }
    }

    function validateDescription() {
        let description = content
        if (!description.length) {
            setDescriptionError("Topic Description is required")
            return true
        }
        else {
            setDescriptionError(null)
            return false
        }
    }

    function validateKeyword() {
        if (!keywordTags.length) {
            setKeywordsError("No Keyword Entered")
            return true
        }
        else {
            setKeywordsError(null)
            return false
        }
    }

    function validatePhoto() {
        if (!topicImage) {
            setTopicImageError("Please select a Cover Photo for the Topic!")
            return true
        }
        else {
            setTopicImageError(null)
            return false
        }
    }

    function validateFiles() {
        if (!files.length && !contentLink) {
            setFilesError("Please upload a topic related study material!")
            return true
        }
        else {
            setFilesError(null)
            return false
        }
    }

    function keywordKeyPressHandler(e) {
        e.stopPropagation()
        if (e.key === 'Enter' || e.key === 'ENTER') {
            let currentKeyword = e.target.value.trim()
            if (currentKeyword.length) {
                let tempTags = [...keywordTags]
                tempTags.push(currentKeyword)
                setKeywordTags(tempTags)
                e.target.value = ''
                return false
            }
        }
    }

    const cancelHandler = () => {
        dispatch(resetEdit())
        history.push('/topics')
    }

    const resetForm = () => {
        selectCourseRef.current.value = ''
        setTopicImage(null)
        setTopicImageUrl(null)
        topicNameRef.current.value = ''
        setContent('')
        setKeywordTags([])
        setQuizSwitchStatus(true)
        setTopicEnabledSwitchStatus(true)
        setFiles([])
        dropzoneRef.current.acceptedFiles = []
    }

    useEffect(() => {
        if (formStatus.success && !formStatus.error) {
            if (editState.flag) {
                dispatch(resetEdit())
                toast({
                    title: "Topic Edited Successfully!",
                    description: "Topic Edited!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                })
                history.push('/topics')
            }
            else {
                toast({
                    title: "Topic Added Successfully!",
                    description: "Topic Added!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                })
            }
            if (buttonClicked === 1) {
                history.push('/topics')
            }
            else {
                resetForm()
            }
        }
        else if (formStatus.error) {
            toast({
                title: "Something went wrong!",
                description: "Error!",
                status: "error",
                duration: 1000,
                isClosable: true,
            })
        }
        // eslint-disable-next-line
    }, [formStatus.success, formStatus.error, editState.flag])

    useEffect(() => {
        dispatch(loadCourses())
        if (editState.flag && topicData.length > 0) {
            dispatch(setHeaderText('Edit Topic'))
            preFillForm()
        }
        else {
            dispatch(setHeaderText('Add Topic'))

        }
        // eslint-disable-next-line
    }, [dispatch, editState, topicData])

    function validateSelectCourse() {
        let selectedCourse = selectCourseRef.current.value.trim()
        if (!selectedCourse.length) {
            setSelectCourseError("Select a Course!")
        }
    }

    function removeTagHandler(keyword) {
        setKeywordTags(keywordTags.filter(tag => tag !== keyword))
    }

    useEffect(() => {
        dispatch(selectedMenu(2))
        if (history.location.state) {
            dispatch(loadTopics())
            dispatch(setEdit(history.location.state.id))
        }
        return () => {
            dispatch(resetFormStatus())
            dispatch(resetEdit())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => { }, [topicImageError])

    const validateFields = () => {
        return validateSelectCourse() || validatePhoto() || validateTopicName() || validateDescription() || validateFiles() || validateKeyword()
    }

    const preFillForm = () => {
        let currentTopic = topicData.find(topic => topic.id === editState.id)
        console.log(currentTopic)
        setTopicImage(currentTopic.cover_image.replaceAll(" ", "%20"))
        setTopicImageUrl(currentTopic.cover_image.replaceAll(" ", "%20"))
        setTopicEnabledSwitchStatus(currentTopic.status.toUpperCase() === 'Y')
        setContent(currentTopic.description)
        topicNameRef.current.value = currentTopic.title
        // selectCourseRef.current.value = coursesData.find(course => course.id.toString() === currentTopic.course_id.toString()).title || ''
        setKeywordTags(currentTopic.keywords ? currentTopic.keywords.split(', ') : [])
        setQuizSwitchStatus(currentTopic.quiz_status.toUpperCase() === 'Y')
        if (currentTopic.content_url) {
            setContentLink(currentTopic.content_url)
        }
        /* 
        "title":"BCA study",
    "description": "BCA study",
    "cover_image": "www.goole.com",
    "content_url": "www.google.com",
    "status": "Y"
         */
    }

    const updateTopic = () => {
        let currentTopic = topicData.find(topic => topic.id === editState.id)
        let formData = { ...currentTopic }
        let title = topicNameRef.current.value.trim()
        let description = content;
        let status = topicEnabledSwitchStatus ? "Y" : "N"
        let keywords = keywordTags.join(' ')
        let quiz_status = quizSwitchStatus ? 'Y' : 'N'

        if (currentTopic.title !== title) {
            formData["title"] = title
        }
        if (currentTopic.description !== description) {
            formData["description"] = description
        }

        if (currentTopic.status.toUpperCase() !== status) {
            formData["status"] = status
        }

        if (currentTopic.keywords !== keywords) {
            formData["keywords"] = keywords
        }

        if (currentTopic.quiz_status !== quiz_status) {
            formData["quiz_status"] = quiz_status
        }

        if (currentTopic.cover_image_url !== topicImage) {
            formData["cover_image_url"] = topicImage
        }
        if (files.length > 0) {
            // console.log(files)
            formData["presentation"] = files[0]
        }

        // console.log(formData)
        // let updatedData = new FormData()
        // for(let key in formData){
        //     console.log(key, formData[key])
        //     updatedData.append(key, formData[key])
        // }

        dispatch(updateTopicForm(formData, editState.id))
    }

    const addNewTopic = () => {
        let formData = new FormData()
        let courseId = coursesData.find(course => course.title === selectCourseRef.current.value).id
        formData.append("course_id", courseId)
        formData.append("title", topicNameRef.current.value.trim())
        formData.append("description", content)
        formData.append("keywords", keywordTags.join(' '))
        formData.append("cover_image_url", topicImage)
        formData.append("content_url", 'www.google.com')
        formData.append("status", topicEnabledSwitchStatus ? "Y" : "N")
        formData.append("quiz_status", quizSwitchStatus ? "Y" : "N")
        if (files.length > 0) {
            formData.append("presentation", files[0])
        }

        dispatch(submitTopicForm(formData))
    }


    const submitHandler = () => {
        if (validateFields()) {
            return
        }
        else {
            if (editState.flag) {
                updateTopic()
            }
            else {
                addNewTopic()
            }
        }
    }

    const addAndRepeatHandler = () => {
        setButtonClicked(0)
        submitHandler()
    }

    const addHandler = () => {
        setButtonClicked(1)
        submitHandler()
    }


    useEffect(() => {
        if (topicImage) {
            if (typeof topicImage === "object") {
                let extension = topicImage.name.substring(topicImage.name.lastIndexOf('.') + 1)
                let acceptedExtensions = ['jpeg', 'jpg', 'png']
                if (!acceptedExtensions.includes(extension.toLowerCase())) {
                    setTopicImageError('Invalid file type')
                    setTopicImage(null)
                    setTopicImageUrl(null)
                }
                else if ((topicImage.size / (1024 * 1024)) > 0.5) {
                    setTopicImageError("Please upload files of size less than or equal to 512 kb!");
                    setTopicImageUrl(null)
                    setTopicImage(null);
                }
                else {
                    setTopicImageUrl(URL.createObjectURL(topicImage))
                }
            }
        }
    }, [topicImage])

    useEffect(() => {
        console.log(topicImageUrl)
    }, [topicImageUrl])

    useEffect(() => {
        if (editState.flag && topicData.length > 0 && coursesData.length > 0) {
            let currentTopic = topicData.find(topic => topic.id === editState.id)
            selectCourseRef.current.value = coursesData.find(course => course.id.toString() === currentTopic.course_id.toString()).title || ''
        }
        // eslint-disable-next-line
    }, [coursesData, topicData])

    const dropHandler = (file) => {
        setFiles(file)
        setFilesError(null)
    }

    return (
        <Box
            flexGrow='1'
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box width={['95%', '95%', '90%', '85%']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} alignItems={['center', 'center', 'flex-start', 'flex-start']} d='flex' mb='2rem' flexDirection='column'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }} mb='2rem'>{headerText}</Text>
                <Box width={['100%', '100%', '100%', '85%']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} alignItems={['center', 'center', 'flex-start', 'flex-start']} d='flex'>

                    <Box
                        style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '90%' }}
                        pointerEvents={formStatus.isSubmitting ? 'none' : 'all'}
                    >


                        <FormControl isInvalid={selectCourseError}>
                            <FormLabel variant='custom' htmlFor="select_course" style={{ fontFamily: 'Mulish, sans-serif' }}>Select Course</FormLabel>
                            <Select
                                id="select_course"
                                width={['100%', '100%', '90%', '85%']}
                                border='1px solid rgba(0, 0, 0, 0.1)'
                                borderRadius="13px"
                                height='40px'
                                bgColor='white'
                                placeholder='Select Course'
                                ref={selectCourseRef}
                                onChange={() => setSelectCourseError(null)}
                            >
                                {coursesData.length > 0 && coursesData.map((course, idx) => <option key={idx} value={course.title}>{course.title}</option>)}
                            </Select>
                            <FormErrorMessage fontSize='sm'>{selectCourseError}</FormErrorMessage>
                        </FormControl>


                        <FormControl isInvalid={topicImageError}>
                            <FormLabel variant='custom' htmlFor="add_photo" style={{ fontFamily: 'Mulish, sans-serif' }}>Cover Image</FormLabel>
                            <Box width='140px' id='add_photo' position='relative' >
                                <label htmlFor="add_photo_helper">
                                    <Button
                                        as='span'
                                        width='140px'
                                        height='140px'
                                        bg='white'
                                        borderRadius='xl'
                                        fontWeight='800'
                                        fontSize={['12px', '14px', '16px', '18px']}
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                        color='#E4B716'
                                        d='flex'
                                        flexDir='column'
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        cursor='pointer'
                                        _hover={{ bg: "white", bgImage: topicImageUrl ? topicImageUrl : null, bgRepeat: 'no-repeat', bgSize: 'cover', bgPosition: 'center' }}
                                        bgImage={topicImageUrl ? topicImageUrl : null}
                                        bgRepeat='no-repeat'
                                        bgSize='cover'
                                        bgPosition='center'
                                    >
                                        {
                                            !topicImageUrl &&
                                            <>
                                                <AddPhoto style={{ marginBottom: '0.5rem' }} />
                                                Add Photo
                                            </>
                                        }
                                    </Button>
                                    {
                                        topicImageUrl &&
                                        <Circle
                                            size='30px'
                                            bg='white'
                                            position='absolute'
                                            right='-15px'
                                            bottom='10px'
                                            boxShadow='xl'
                                            border="1px solid rgba(0, 0, 0, 0.1)"
                                            cursor='pointer'
                                        >
                                            <AddPhoto width='15px' height='15px' />
                                        </Circle>
                                    }
                                </label>
                                <input
                                    accept="image/*"
                                    id="add_photo_helper"
                                    name="add_photo_helper"
                                    type="file"
                                    onChange={(e) => {
                                        setTopicImage(e.target.files[0])
                                        setTopicImageError(null)
                                    }
                                    }
                                    style={{ display: 'none' }}
                                />
                            </Box>
                            <FormErrorMessage fontSize='sm'>{topicImageError}</FormErrorMessage>
                            {topicImage && <Text mt='1' fontWeight='600' color='#666666' style={{ fontFamily: 'Mulish, sans-serif' }} fontSize='md'>Attached file : <span style={{ fontSize: '13px' }}><em>{topicImage.name ? `${topicImage.name} - ${(topicImage.size / (1024 * 1024)).toFixed(2)} MB` : topicImage}</em></span></Text>}
                        </FormControl>


                        <FormControl isInvalid={topicNameError}>
                            <FormLabel variant='custom' htmlFor="topic_name" style={{ fontFamily: 'Mulish, sans-serif' }}>Topic Title</FormLabel>
                            <Input
                                id="topic_name"
                                width={['100%', '100%', '90%', '85%']}
                                border='1px solid rgba(0, 0, 0, 0.1)'
                                borderRadius="13px"
                                height='40px'
                                bgColor='white'
                                ref={topicNameRef}
                                onChange={() => setTopicNameError(null)}
                            />
                            <FormErrorMessage fontSize='sm'>{topicNameError}</FormErrorMessage>
                        </FormControl>



                        <FormControl isInvalid={descriptionError}>
                            <FormLabel variant='custom' htmlFor="topic_description" style={{ fontFamily: 'Mulish, sans-serif' }}>Topic Description</FormLabel>
                            <Box width={["100%", "100%", "90%", "85%"]} bg='white' borderRadius='13px' minH='200px' >
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    config={{
                                        readOnly: false,
                                        uploader: { url: 'none' },
                                        removeButtons: ["image", "video", "file", "table", "fullsize", "link", "find"],
                                        disablePlugins: ["image-properties", "image-processor", "image", "video", "media", "file", "table", "class-span", "resize-cells", "select-cells", "table-keyboard-navigation", "print", "preview", "fullsize", "search", "link"],
                                    }}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                />
                            </Box>
                            <FormErrorMessage fontSize='sm'>{descriptionError}</FormErrorMessage>
                        </FormControl>

                        <Dropzone
                            ref={dropzoneRef}
                            noClick
                            noKeyboard
                            accept={'video/mp4, video/mpeg, video/ogg, video/quicktime, video/webm, video/x-m4v, video/x-msvideo, video/x-ms-wmv, audio/mpeg, audio/mp4, audio/ogg, audio/vnd.wav, audio/vorbis, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf, text/plain, '}
                            onDrop={dropHandler}
                        >
                            {({ getRootProps, getInputProps, acceptedFiles, fileRejections }) => {

                                const fileRejectionItems = fileRejections.map(({ errors }) => (
                                    errors.map(e => (
                                        <li key={e.code}>{"Unsupported File Type!"}</li>
                                    ))
                                ));


                                return (
                                    <Box>
                                        <Box {...getRootProps({ className: 'dropzone' })} d='flex' justifyContent='center' alignItems='center' flexDir='column' width={['100%', '100%', '90%', '85%']} height='' p='1rem' backgroundColor='white' borderRadius='16px' border='2px dashed rgba(0, 0, 0, 0.1)'>
                                            <input {...getInputProps()} />
                                            <UploadIcon />
                                            <Text
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                fontWeight='700'
                                                fontSize={['10px', '14px', '16px', '18px']}
                                                color='#666666'
                                                m={['0.5rem', '0.75rem', '1rem', '1rem']}
                                            >
                                                Drag & Drop Document / Video / Presentation
                                            </Text>
                                            <Text
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                fontWeight='600'
                                                fontSize={['10px', '11px', '12px', '14px']}
                                                color='#666666'
                                                mb={['0.5rem', '0.75rem', '1rem', '1rem']}
                                            >
                                                OR
                                            </Text>
                                            <Button
                                                bgColor='#8dc099'
                                                color='white'
                                                borderRadius='lg'
                                                p={['6px 15px', '8px 20px', '12px 30px']}
                                                _hover={{ bg: "#7eac88" }}
                                                onClick={openDialog}
                                            >
                                                Browse Files
                                            </Button>
                                        </Box>
                                        <aside style={{ paddingTop: '1rem', paddingLeft: '2rem' }}>
                                            {fileRejectionItems && <ul style={{ color: 'red' }}>{fileRejectionItems}</ul>}
                                        </aside>
                                    </Box>
                                );
                            }}
                        </Dropzone>
                        {
                            files.length > 0 && !editState.flag &&
                            <Box
                                pl='2rem'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='16px'
                                color='#666666'
                            >
                                <li>{files[0].path} - {(files[0].size / (1024 * 1024)).toFixed(2)} MB</li>
                            </Box>
                        }

                        {
                            editState.flag && contentLink &&
                            <Box
                                pl='2rem'
                            >
                                <FormLabel variant='custom' fontSize='16px' style={{ fontFamily: 'Mulish, sans-serif' }}>Uploaded Study Material (Click filename to Open) - </FormLabel>
                                <li><Link href={contentLink} target='_blank' rel='noreferrer noopener'>{contentLink.substring(contentLink.lastIndexOf('/') + 11)}</Link></li>
                            </Box>
                        }
                        {
                            filesError &&
                            <Box
                                mt='-2rem'
                            >
                                <Text fontSize='sm' color='red.600'>{filesError}</Text>
                            </Box>
                        }

                        <FormControl isInvalid={keywordsError} onSubmit={() => false}>
                            <FormLabel variant='custom' htmlFor="keywords" style={{ fontFamily: 'Mulish, sans-serif' }}>Keywords</FormLabel>
                            <Box
                                d='flex'
                                bgColor='white'
                                width={['100%', '100%', '90%', '85%']}
                                border='1px solid rgba(0, 0, 0, 0.1)'
                                borderRadius="13px"
                                minHeight='40px'
                                p='1'
                                flexWrap='wrap'
                            >
                                <Box d={keywordTags.length > 0 ? 'flex' : 'none'} justifyContent='space-around'>
                                    {
                                        keywordTags.length > 0 && keywordTags.map((tag, idx) => <Tags keyword={tag} removeTag={removeTagHandler} key={idx} />)
                                    }
                                </Box>
                                <Input
                                    id="keywords"
                                    bgColor="white"
                                    placeholder="Enter Keyword"
                                    onKeyDown={keywordKeyPressHandler}
                                    border="none"
                                    outline="none"
                                    p="5px"
                                    minW="40%"
                                    focusBorderColor="none"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                    fontWeight="600"
                                    fontSize="16px"
                                    onChange={() => setKeywordsError(null)}
                                    height='100%'
                                    color='#999999'
                                />

                            </Box>
                            <FormErrorMessage fontSize='sm'>{keywordsError}</FormErrorMessage>
                        </FormControl>


                        <Box width={['100%', '100%', '90%', '85%']} d='flex' justifyContent='space-between' alignItems='center'>
                            <Text width={['55%', '65%', '65%', '65%', '75%']} style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='600' fontSize={['16px', '16px', '16px', '18px']} color='#666666'>Is this topic available for quiz?</Text>
                            <SwitchComponent trueText='Yes' falseText='No' bgColor='#fdab3d' switchStatus={quizSwitchStatus} setSwitchStatus={setQuizSwitchStatus} />
                        </Box>
                        <Box width={['100%', '100%', '90%', '85%']} d='flex' justifyContent='space-between' alignItems='center'>
                            <Text width={['55%', '65%', '65%', '65%', '75%']} style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='600' fontSize={['16px', '16px', '16px', '18px']} color='#666666'>Topic Status</Text>
                            <SwitchComponent trueText='Enable' falseText='Disable' bgColor='#fd5f3a' switchStatus={topicEnabledSwitchStatus} setSwitchStatus={setTopicEnabledSwitchStatus} />
                        </Box>
                        <Box width={['100%', '100%', '90%', '85%']} d='flex' flexDir={['column', 'column', 'row', 'row']} justifyContent={['center', 'center', 'flex-start', 'flex-start']} mt='2rem'>
                            {
                                !editState.flag && <Button
                                    bgColor='#429fff'
                                    color='white'
                                    borderRadius='lg'
                                    p={['6px 15px', '8px 20px', '12px 30px']}
                                    _hover={{ bg: "#3b8fe4" }}
                                    isLoading={buttonClicked === 0 && formStatus.isSubmitting}
                                    onClick={addAndRepeatHandler}
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    fontWeight='800'
                                    fontSize={['13px', '14px', '16px']}
                                    mr={['0', '0', '20px', '20px']}
                                    mb={['20px', '20px', '0', '0']}
                                    loadingText='Adding...'
                                    disabled={buttonClicked === 1 && formStatus.isSubmitting}
                                >
                                    Add & Repeat
                                </Button>
                            }
                            <Button
                                bgColor='#429fff'
                                color='white'
                                borderRadius='lg'
                                p={['6px 15px', '8px 20px', '12px 30px']}
                                _hover={{ bg: "#3b8fe4" }}
                                isLoading={buttonClicked === 1 && formStatus.isSubmitting}
                                onClick={addHandler}
                                loadingText={editState.flag ? 'Updating...' : 'Adding...'}
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontWeight='800'
                                fontSize={['13px', '14px', '16px']}
                                mr={['0', '0', '20px', '20px']}
                                mb={['20px', '20px', '0', '0']}
                                disabled={buttonClicked === 0 && formStatus.isSubmitting}
                            >
                                {editState.flag ? 'Update Topic' : 'Add Topic'}
                            </Button>
                            <Button
                                bgColor='white'
                                color='#999999'
                                borderRadius='lg'
                                border='1px solid rgba(0, 0, 0, 0.2)'
                                p={['6px 15px', '8px 20px', '12px 30px']}
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontWeight='800'
                                fontSize={['13px', '14px', '16px']}
                                disabled={formStatus.isSubmitting}
                                onClick={cancelHandler}
                            >
                                Cancel
                            </Button>
                        </Box>
                        {/* {formStatus.error &&
                            <Text
                                fontSize='sm'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                color='red.500'
                            >
                                {formStatus.error}
                            </Text>} */}
                    </Box>

                </Box>
            </Box >
        </Box >
    )
}